import { createAction } from '@reduxjs/toolkit';

export const scrollToBase = createAction('SCROLL_TO_BASE');

export const viewChangeRequested = createAction<string>('VIEW_CHANGE_REQUESTED');
